import { FrameworkConfiguration } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';

export function configure(config: FrameworkConfiguration) {
  config.feature(PLATFORM.moduleName('venminder-default/resources/features/index', 'global'));
}
